export class UnexpectedResponseError extends Error {
    constructor(message: string) {
        super(`Unexpected response: ${message}`);
        this.name = 'UnexpectedResponseError';
    }
}
